var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlertTriangle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.18353 1.53898C6.58764 1.80556 6.13239 2.60226 5.22187 4.19566L2.73605 8.54585L2.73605 8.54586C1.83765 10.1181 1.38845 10.9042 1.45823 11.5488C1.5191 12.111 1.8152 12.6213 2.2732 12.9531C2.79825 13.3335 3.70364 13.3335 5.51443 13.3335H10.4861C12.2969 13.3335 13.2023 13.3335 13.7273 12.9531C14.1853 12.6213 14.4814 12.111 14.5423 11.5488C14.6121 10.9042 14.1629 10.1181 13.2645 8.54585L10.7786 4.19566C9.86812 2.60226 9.41286 1.80556 8.81698 1.53898C8.29731 1.3065 7.7032 1.3065 7.18353 1.53898ZM8.91226 4.98819C8.95949 4.45722 8.54118 4.00004 8.00811 4.00004C7.46932 4.00004 7.04913 4.46664 7.10536 5.00249L7.50321 8.79388C7.52992 9.04842 7.74454 9.2417 8.00048 9.2417H8.07637C8.33535 9.2417 8.55146 9.04395 8.57441 8.786L8.91226 4.98819ZM7.53955 11.1948C7.67923 11.3321 7.84732 11.4008 8.04381 11.4008C8.17165 11.4008 8.28884 11.3688 8.39538 11.3049C8.50191 11.241 8.58714 11.1558 8.65106 11.0492C8.71734 10.9403 8.75167 10.8208 8.75404 10.6906C8.75167 10.4964 8.68065 10.3307 8.54097 10.1934C8.40129 10.0537 8.23557 9.98388 8.04381 9.98388C7.84732 9.98388 7.67923 10.0537 7.53955 10.1934C7.39987 10.3307 7.33122 10.4964 7.33358 10.6906C7.33122 10.8871 7.39987 11.0551 7.53955 11.1948Z",
    fill: "#EA714B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertTriangle);
export default __webpack_public_path__ + "static/media/alert-triangle.93573562d02552aa560126e095cb89d6.svg";
export { ForwardRef as ReactComponent };